import { getRuntimeBaseUrl } from "../runtime-env";

export const MIXPANEL_PROJECT_ID = process.env.NX_PUBLIC_MIXPANEL_PROJECT_ID;

export const CIQ_CLIENT_ID = process.env.NX_PUBLIC_CIQ_CLIENT_ID;

export const BASE_URL = getRuntimeBaseUrl();

export const LINKEDIN_AUTH_CLIENT_ID =
  process.env.NX_PUBLIC_LINKEDIN_AUTH_CLIENT_ID;
